(function () {
  var lastFocused = null;
  var currentDialog = null;

  // --- Helpers from Klaviyo documentation (for JAWS and other screen readers) ---
  function isAriaHiddenTrue(el) {
    return el ? el.getAttribute('aria-hidden') === 'true' : false;
  }
  function isModal(node) {
    if (node.children.length !== 1) return false;
    return Array.from(node.children[0].classList)
      .some(function (c) { return c.startsWith('kl-private-reset'); });
  }
  function getTopLevelDomElements() {
    return Array.from(document.body.children).filter(function (node) {
      if (node.nodeType !== Node.ELEMENT_NODE) return false;
      var tag = node.tagName.toLowerCase();
      return tag !== 'script' && tag !== 'link' && tag !== 'iframe' &&
             tag !== 'style' && !isModal(node);
    });
  }
  function hideBackground() {
    getTopLevelDomElements().forEach(function (el) {
      if (!isAriaHiddenTrue(el)) {
        el.setAttribute('kl-aria-hidden', 'true');
        el.setAttribute('aria-hidden', 'true');
      }
    });
  }
  function showBackground() {
    getTopLevelDomElements().forEach(function (el) {
      if (el.hasAttribute('kl-aria-hidden')) {
        el.removeAttribute('kl-aria-hidden');
        el.removeAttribute('aria-hidden');
      }
    });
  }

  // --- Identity & focus ---
  function focusables(root) {
    return Array.from(root.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetParent !== null; });
  }

  function onKeydown(e) {
    if (!currentDialog) return;
    if (e.key === 'Escape') {
      var close = currentDialog.querySelector('[class*="close"], button[aria-label]');
      if (close) close.click();
      return;
    }
    if (e.key !== 'Tab') return;
    var items = focusables(currentDialog);
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  function enhance(formId) {
    var el = document.querySelector('.klaviyo-form-' + formId) ||
             document.querySelector('[class*="kl-private-reset"]');
    if (!el) return;

    currentDialog = el;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');

    // Use the real form heading as the accessible name
    var heading = el.querySelector('h1, h2, h3');
    if (heading) {
      if (!heading.id) heading.id = 'kl-dialog-title-' + formId;
      el.setAttribute('aria-labelledby', heading.id);
    } else {
      el.setAttribute('aria-label', 'Subscribe to the newsletter'); // adjust the text
    }

    // Accessible name for the X button
    el.querySelectorAll('button, [role="button"]').forEach(function (b) {
      var hasName = (b.textContent || '').trim() || b.getAttribute('aria-label');
      if (!hasName) b.setAttribute('aria-label', 'Close');
    });

    hideBackground();
    document.addEventListener('keydown', onKeydown, true);

    var items = focusables(el);
    if (items.length) setTimeout(function () { items[0].focus(); }, 50);
  }

  function teardown() {
    document.removeEventListener('keydown', onKeydown, true);
    showBackground();
    currentDialog = null;
    if (lastFocused && document.body.contains(lastFocused)) lastFocused.focus();
  }

  window.addEventListener('klaviyoForms', function (e) {
    if (e.detail.type === 'open') {
      lastFocused = document.activeElement;
      setTimeout(function () { enhance(e.detail.formId); }, 100);
    }
    if (e.detail.type === 'close') {
      teardown();
    }
  });
})();